import { Tabs, TabsList, TabsTrigger } from "../../../components/shadcn/Tabs";
import {
  DrawCircle,
  DrawSquare,
  DrawPolygon,
} from "../../../components/icons";

export interface SelectionToolbarProps {
    drawingMode: string;
    onDrawingModeChange: (newDrawingMode: string | null) => void;
}

export const SelectionToolbar = ({
      drawingMode,
      onDrawingModeChange,
}: SelectionToolbarProps) => {
    const handleShapeClick = (shape: string) => {
      // Always call onDrawingModeChange, even if clicking the same shape
      // This re-activates draw mode after a shape has been drawn
      onDrawingModeChange(shape);
    };

    return (
        <Tabs
        value={drawingMode}
        onValueChange={(value) => onDrawingModeChange(value)}
      >
        <TabsList>
          <TabsTrigger
            value="rectangle"
            title="Select using a rectangle"
            onClick={() => handleShapeClick("rectangle")}
          >
            <div className="flex flex-row items-center gap-2">
                <DrawSquare width={14} height={14} />
                <span>Square</span>
            </div>
          </TabsTrigger>
          <TabsTrigger
            value="circle"
            title="Select using a circle"
            onClick={() => handleShapeClick("circle")}
          >
            <div className="flex flex-row items-center gap-2">
                <DrawCircle width={14} height={14} />
                <span>Circle</span>
            </div>
          </TabsTrigger>
          <TabsTrigger
            value="polygon"
            title="Select using a polygon"
            onClick={() => handleShapeClick("polygon")}
          >
            <div className="flex flex-row items-center gap-2">
                <DrawPolygon width={14} height={14} />
                <span>Polygon</span>
            </div>
          </TabsTrigger>
        </TabsList>
      </Tabs>
    )
}